<template>
   <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <div class="col text-right row justify-end">
          </div>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Nhật ký chăm sóc lô</div>
          </div>
          <div class="col-xs-12 col-md-11 col-lg-8 row">
            <div class="col-xs-12 col-md-4 q-pa-md">
              <div class="row justify-between">
                <q-input label="Ngày" class="col-11" flat readonly v-model="filterDate">
                  <template v-slot:append>
                  </template>
                </q-input>
                <q-icon name="event" class="cursor-pointer col-1 self-center" size="32px">
                  <q-popup-proxy d ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date flat v-model="filterDate" mask="DD/MM/YYYY" minimal @input="() => $refs.qDateProxy.hide()" />
                  </q-popup-proxy>
                </q-icon>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 q-pa-md">
              <q-select clearable emit-value v-model="farm" :options="farms" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, farm ,'name')" label="Nông trường">
                <template v-slot:prepend>
                  <q-icon name="filter_vintage" />
                </template>
              </q-select>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 q-pa-md row">
              <q-select class="col-9" clearable emit-value v-model="lot" :options="lotOptions" option-value="id" option-label="name" label="Lô" :readonly="farm ? farm.listLot ? false : false : true">
                <template v-slot:prepend>
                  <q-icon name="local_florist" />
                </template>
              </q-select>
              <q-btn class="col" ripple icon="cloud_download" flat color="black" size="20px" @click="download" :loading="load"/>
            </div>
          </div>
        </q-card>

        <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
        <q-table
          :data="reportsData"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :loading="load"
          :pagination.sync= pagination
          :hide-bottom="!_.isEmpty(reportsData)"
          >
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="!props.row.deleted">
              <q-td @click.native="routeReportData(props.row._id)" class="label-xs-right text-center">{{ props.row.__index+1 }}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.date" class="label-xs-right text-center">{{props.row.date instanceof firebase().firestore.Timestamp === true ? moment((props.row.date).toDate()).format(defaultDateFormat): props.row.date }}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.farm" class="label-xs-right text-center">{{ $getNameById(farmStore.list, props.row.farm ,'name') }}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.lot" class="label-xs-right text-center">{{ props.row.lot}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.job" class="label-xs-right text-center">{{ $getNameById(jobStore.list, props.row.job ,'name')}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.totalWeight" class="label-xs-right text-center">{{ props.row.totalWeight}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.unit" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.list, props.row.job ,'unit') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.type" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.type) ? $getNameById(workerTypes, props.row.worker.type,'label') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.number" class="label-xs-right text-center">{{ props.row.worker.number}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.meka" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.meka) ? $getNameById(mekaStore.list, props.row.worker.meka ,'displayName') : ''}}</q-td>
              <q-td @click.native="routeReportData(props.row._id)" v-if="props.colsMap.supervisor" class="label-xs-right text-center">{{ props.row.supervisor }}</q-td>
              <q-td class="label-xs-right text-center" @click.native="clickDeleteButton(props)" >
                <q-btn ripple flat round color="black" icon="delete"/>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Float add button -->
        <q-page-sticky class="q-ma-md item-center" :style="'right:unset; left: '+ ($q.screen.width/2 - 45) + 'px'">
          <q-btn fab icon="add" color="green" @click="routeReportData(null,'CREATE')"/>
        </q-page-sticky>
        <!-- Delete Record -->
        <q-dialog v-model="deleteDialog" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <q-avatar icon="delete" color="black" text-color="white"/>
              <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn ripple flat icon="clear" v-close-popup/>
              <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
            </q-card-actions>
          </q-card>
        </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
/* eslint-disable no-unused-vars */
import moment from "moment"
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
const { Timestamp } = firebase.firestore
const XlsxPopulate = require('xlsx-populate')

export default {
  props: {
    rootModel: Object,
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 0,
        sortBy: 'date',
        descending: true,
      },
      collection: "Reports",
      reports: null,
      reportId: null,
      farm: null,
      lot: null,
      farms: null,
      lots: null,
      tableKey: 0,
      deleteDialog: false,
      load: false,
      selectedRowIndex: null,
      defaultDateFormat: 'DD/MM/YYYY',
      filterDate: moment.utc().format('DD/MM/YYYY'),
      workerTypes: [
        {
          label: 'Công nhật',
          value: 'congnhat',
          id: 'congnhat'
        },
        {
          label: 'Công khoán',
          value: 'khoan',
          id: 'khoan'
        }
      ],
      headers: [{
        label: "No",
        align: "center",
        name: "no",
        },
        {
        label: "Ngày",
        align: "center",
        name: "date",
        field: 'date',
        sortable: true,
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm",
        },
        {
        label: "Lô",
        align: "center",
        name: "lot",
        },
        {
        label: "Nội dung CV",
        align: "center",
        name: "job",
        },
        {
        label: "Khối lượng",
        align: "center",
        name: "totalWeight",
        },
        {
        label: "Đơn vị tính",
        align: "center",
        name: "unit",
        },
        {
        label: "Loại nhân công",
        align: "center",
        name: "type",
        },
        {
        label: "Số lượng",
        align: "center",
        name: "number",
        },
        {
        label: "Meka",
        align: "center",
        name: "meka",
        },
        {
        label: "Giám sát",
        align: "center",
        name: "supervisor",
        }],
        csvFields: [
        {
        label: 'STT',
        },
        {
        label: 'Ngày',
        value: 'date',
        },
        {
        label: 'Giám sát',
        value: 'supervisor',
        },
        {
        label: 'Nông trường',
        value: 'farm'
        },
        {
        label: 'Lô',
        value: 'lotID',
        key: 'lotID',
        type: 'number',
        required: true
        },
        // {
        // label: 'Ô',
        // value: 'slots',
        // key: 'slots',
        // type: 'array',
        // },
        {
        label: 'Mã CV',
        value: 'job',
        key: 'jobID',
        required: true,
        type: {
          showLabel: 'jobCode',
          listToFind: 'vm.jobStore.list'
          }
        },
        {
        label: 'Hạng mục công việc',
        value: 'job',
        },
        {
        label: 'Loại',
        value: 'worker.type',
        key: 'jobType',
        required: true,
        type: {
          showLabel: 'jobType',
          listToFind: 'vm.workerTypes'
          }
        },
        {
        label: 'Số lượng',
        value: 'worker.number',
        key: 'jobType',
        required: true,
        },
        // {
        // label: 'Định mức (Công/ngày)',
        // value: 'quotaTask',
        // key: 'quotaTask',
        // type: 'number',
        // required: true
        // },
        {
        label: 'Khối lượng',
        value: 'totalWeight',
        key: 'totalWeight',
        type: 'number',
        required: true
        },
        {
        label: 'Nhân công',
        value: 'worker.meka',
        key: 'meka',
        required: true,
        type: {
          showLabel: 'displayName',
          listToFind: 'vm.mekaStore.list'
          }
        },
        {
        label: 'ĐVT',
        value: 'unit',
        },
      ],
      dialogEdit: false,
      curUser: '',
      optionsreports: [],
    }
  },
  created() {
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    reportsData() {
      let data = this.reports ? !this.farm ? this.reports : this.reports.filter(v => this.farm && this._.isEqual(v.farm,this.farm) && (this.lot ? this._.isEqual(v.lot,this.lot) : true )) : []
      return data.sort((a, b) => a.farm === b.farm ? this.$getNameById(this.jobStore.list, a.job ,'name').localeCompare(this.$getNameById(this.jobStore.list, b.job ,'name')) : a.farm - b.farm)
    },
    lotOptions() {
      // eslint-disable-next-line
      this.lot = null
      return this.farm ? this.$getNameById(this.farmStore.list, this.farm ,'listLot') : []
    },
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ])
  },
  watch: {
    filterDate() {
      this.fetchData()
    }
  },
  methods: {
    async fetchData () {
      let vm = this
      vm.load = true
      vm.reports = null
      let rp = vm.queryBuilder()
      let f = this.farmStore
      let j = this.jobStore
      Promise.all([rp, f]).then(res => {
        vm.reports = res[0]
        vm.reports
        vm.farms = res[1].list
        vm.curUser = vm.curUser ? '' : vm.$store.getters.user.email
        vm.load = false
      })
    },
    queryBuilder() {
      const regexFarm = /(^F[0-9]M$)/
      let roles = this.permission.roles
      return this.$query([this.collection], [['date', '==', Timestamp.fromDate(moment.utc(this.filterDate, 'DD/MM/YYYY').toDate())],['deleted','==', false]]).then(data => {
        if(this.permission.roles.hasOwnProperty('BOM')) {
          return data.data
        } else {
          let fm = Object.keys(roles).filter((item) => regexFarm.test(item)).map(i => parseInt(i[1]))
          let filter = []
          data.data.forEach(item => {
            if(item.supervisor === this.user.email || fm.indexOf(item.farm) !== -1) {
              filter.push(item)
            }
          })
        return filter
        }
      })
    },
    download() {
      let vm = this
      let model= []

      //fields that need to convert
      let idFields = [
        {
          key:'date',
          name: 'date'
        },
        {
          key:'farm',
          label:'name',
          list: vm.farms,
          name: 'farm'
        },
        {
          key:'lot',
          name: 'lot',
        },
        {
          key:'job',
          label: 'jobCode',
          list: vm.jobStore.list,
          name: 'jobCode'
        },
        {
          key:'job', //object['name'] = find in 'list', where 'key' return 'key'['label']
          label:'name',
          list: vm.jobStore.list,
          name: 'job'
        },
        {
          key:'job',
          label: 'unit',
          list: vm.jobStore.list,
          name: 'unit'
        },
        {
          key:'worker.type',
          label:'label',
          list: vm.workerTypes,
          name: 'type'
        },
        {
          key:'worker.number',
           name: 'workerNumber'
        },
        {
          key:'worker.meka',
          label:'displayName',
          list: vm.mekaStore.list,
          name: 'meka'
        },
        {
          key:'supervisor',
          name: 'supervisor',
        },
        {
          key:'note',
          name: 'note',
        },
        ]

      //convert showing data to array
      //Plans worksheet
      let secondModel = []
      if (!vm._.isEmpty(vm.reports))
      {
        for (let i in vm.reports) {
          //first value is no of line
          let row = [i]
          let field = {}
          let farm = vm.reports[i] && vm.reports[i].farm ? vm.reports[i].farm : '' //for eval
          //add a row
          for (let f in idFields) {
            let value = vm._.get(vm.reports[i], idFields[f].key)
            let list = idFields[f].list
            let name = idFields[f].value
            let label = idFields[f].label
  
            //if value is date type
            if (value instanceof Timestamp) {
              let date = moment((value).toDate()).format(this.defaultDateFormat)
              field[idFields[f].name] = date
              row.push(date)
            }
            else {
              field[idFields[f].name] = list ? vm.$getNameById(list, value, label) : (value instanceof Object) ? (JSON.stringify(value)).substr(1,JSON.stringify(value).length-2) : value
              row.push(field[idFields[f].name])
            }
          }
  
          //pushing details in to secondModel, workSheet
          let details = vm._.get(vm.reports[i], 'details')
  
          vm._.forEach(details, value => {
            let childRow = vm._.cloneDeep(field)
            vm._.forEach(value, (childVal, childKey) => {
              childRow[childKey] = childVal
            })
            secondModel.push(childRow)
          })
            
        }
      }
      let col = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N']

      let colWidth = [
        //details sheet
        [10, //stt,
        20,//ngay,
        20,//nt,
        20,//lo,
        30,//o,
        20,//macv,
        30,//cv,
        20,//kl,
        20,//dvt,
        20,//loai,
        20,//sl,
        20,//meka,
        40,//gs,
        30,//note
        ]
      ]

      //Details worksheet
      let details = [['STT','Ngày','Nông trường', 'Lô','Ô','Mã CV','Hạng mục CV','Khối lượng','ĐVT','Loại nhân công', 'Số lượng','Nhân công','Giám sát','Ghi chú']]
      if (!vm._.isEmpty(secondModel))
      {
        for (let i in secondModel) {
          let row = [i]
          row.push(secondModel[i].date)
          row.push(secondModel[i].farm)
          row.push(vm.$getNameById(vm._.find(vm.farms,{name:secondModel[i].farm}).listLot,secondModel[i].lot, 'name')) //lot name
          row.push(secondModel[i].slots.toString())
          row.push(secondModel[i].jobCode)
          row.push(vm._.find(vm.jobStore.list, {jobCode:secondModel[i].jobCode}).name)
          row.push(secondModel[i].weight)
          row.push(secondModel[i].unit)
          row.push(vm._.find(vm.workerTypes,{label:secondModel[i].type}).label)
          row.push(secondModel[i].workerNumber)
          row.push(secondModel[i].meka)
          row.push(secondModel[i].supervisor)
          row.push(secondModel[i].note)
          details.push(row)
        }
      }

      //Jobs worksheet
      let jobs = [['STT','Mã CV','Hạng mục công việc','Đơn vị']]
      for (let i in vm.jobs) {
        let row = [i]
        row.push(vm.jobs[i].jobCode)
        row.push(vm.jobs[i].name)
        row.push(vm.jobs[i].unit)
        jobs.push(row)
      }

      //Farms worksheet
      let farmSheet = [['STT','Nông trường','Mã nông trường','Lô','Mã lô','Diện tích (Ha)']]
      for (let i in vm.farms) {
        let findLot = vm.farms[i].listLot
        vm._.forEach(findLot, (lot) => {
          let row = []
          row.push(farmSheet.length)
          row.push(vm.farms[i].name)
          row.push(vm.farms[i].farmCode)
          row.push(lot.name)
          row.push(lot.id)
          row.push(lot.area)
          row.push(vm.farms[i].unit)
          farmSheet.push(row)
        })
      }

      //Meka
      let mekaSheet = [['STT','Tên','Mã NV', 'Email', 'SĐT','Ghi Chú']]
      for (let i in vm.mekaStore.list) {
        let row  = [i]
        row.push(vm.mekaStore.list[i].displayName)
        row.push(vm.mekaStore.list[i].mekaId)
        row.push(vm.mekaStore.list[i].email)
        row.push(vm.mekaStore.list[i].mobile)
        row.push(vm.mekaStore.list[i].note)
        mekaSheet.push(row)
      }

      let ext = 'xlsx'
      //Generate a file name
      let fileName = 'Chi-tiet-CV-' + moment.utc(this.filterDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
      
      //generate workbook n worksheet

      XlsxPopulate.fromBlankAsync().then(workbook => {
          workbook.sheet(0).cell("A1").value(details)
          workbook.sheet(0).name('Chi tiết CV').row(1).style("bold", true)
          for (let i in workbook.sheets()) {
            for (let j in colWidth[i]) {
              workbook.sheets()[i].column(col[j]).width(colWidth[i][j])
            }
          }
        return workbook.outputAsync()
        }).then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, `${fileName}.${ext}`)
          }
          else {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            document.body.appendChild(a)
            a.href = url
            a.download = `${fileName}.${ext}`
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }).catch(err => {
          throw err
      })
    },
    routeReportData(reportId, mode) {
      this.$router.push({
        name: '/reports/entry',
        query: {
          id: reportId ? reportId : undefined,
        },
        params: {
          reportId: reportId,
          mode: mode ? mode : undefined
        }
      });
    },
    hasPermission(name) {
      let vm = this
      if (vm.permission && vm.permission[vm.$parent.route]) {
        return vm.permission[vm.$parent.route].all && vm.permission[vm.$parent.route].all.indexOf(name) >= 0
      }
      return false
    },
    clickDeleteButton(props) {
      this.selectedRowIndex = props.row.__index
      this.deleteDialog = true
    },
    async deleteItem() {
      let vm = this
      vm.deleteDialog = false
      vm.tableKey ++
      vm.load = true

      vm.$refs.bar.start()
      let dataSubmit = vm._.cloneDeep(vm.reportsData[vm.selectedRowIndex])
      dataSubmit.deleted = true
      let submitModel = { id: vm.reportsData[vm.selectedRowIndex]._id, data: dataSubmit}
      await vm.$command.execute('updateReport', submitModel).then(async () => {
        vm.$q.notify({
          message: 'Đã lưu thành công',
          color: 'black',
          icon: 'check'
        })
        await this.fetchData()
      },  { mode: 'no-cors'} ).catch((error) => {
        vm.$q.notify({
          message: `Xóa thất bại ${error}`,
          color: 'red',
          icon: 'error'
        })
      })
      vm.$refs.bar ? vm.$refs.bar.stop() : null
    },
    moment(timestamp) {
      return moment(timestamp)
    },
    firebase() {
      return firebase
    }
  }
}

</script>
